export const surveyTypesArr = [
  { id: 1, name: 'ADAPT' },
  { id: 2, name: 'PULSE' },
  { id: 3, name: 'EFFECT' },
  { id: 4, name: 'GOOD_TEAM' },
];

export const languagesArr = [
  { id: 1, name: 'English' },
  { id: 2, name: 'Norwegian' },
  { id: 3, name: 'Swedish' },
];

export const surveyTypes = {
  ADAPT: 'ADAPT',
  PULSE: 'PULSE',
  EFFECT: 'EFFECT',
  GOOD_TEAM: 'GOOD_TEAM',
};

export const formatSurveyTypeLabel = (surveyType: string) => {
  if (surveyType === surveyTypes.GOOD_TEAM) {
    return 'GODE TEAM';
  }
  return surveyType.replace(/_/g, ' ');
};

export const isEffectLikeSurvey = (surveyType: string) =>
  surveyType === surveyTypes.EFFECT || surveyType === surveyTypes.GOOD_TEAM;
